function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="30" height="19" viewBox="0 0 30 19" {...props}><path fillRule="evenodd" d="M26.476 19l-.002-3.63H3.533v3.62H.003L0 1.632c0-2.176 3.538-2.176 3.538 0v10.139H26.42L30 11.76V19h-3.524zm-13.344-7.607H5.693c-1.414 0-1.28-3.244.044-3.244h5.913V5.735c0-1.14.706-1.784 1.482-1.913v-.017h.156c.085-.007.17-.006.254 0H28.05c1.438 0 1.951.463 1.951 1.939V11.4H13.132v-.007zM8.437 6.65c-1.553 0-2.812-1.276-2.812-2.85S6.884.95 8.437.95c1.554 0 2.813 1.276 2.813 2.85S9.99 6.65 8.437 6.65z" /></svg>;
});